form_validator('#loginform',
    {
        email: {
            required: true,
            email: true
        },
        password: {
            required: true
        }
    },
    {}
);

form_validator('#recoverform',
    {
        email: {
            required: true,
            email: true
        }
    },
    {}
);

if ($('#recoverform').length) {
    $('.send-recover-request').on('click', function () {
        if($('#recoverform').valid()) {
            swal({
                    title: "Success!",
                    text: "Thank you for submitting your request. You will receive an e-mail with instructions for resetting your password shortly.",
                    type: "success",
                    showCancelButton: false,
                    confirmButtonClass: "btn-success",
                    confirmButtonText: "OK",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    $('#recoverform').submit();
                });
        }

    });
}

$(document).ready(function () {
    $('#okta__general_saml_login').on('click', (event) => {
        event.preventDefault();
        const email = $('input[name="email"]').val();
        if (email === null || email === '') {
            global_notification('error', 'You need to add your email address.');
            return;
        }
        window.location.href = '/general/saml2/login/' + email;
    })
});